module.exports = __webpack_public_path__ + "linkedin.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linkedin.png
// module id = 1908
// module chunks = 0